/**
 * @desc sku历史报价信息列表
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(params: API.srm.supplierQuotation.getHistoryPrice.Params, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierQuotation/getHistoryPrice`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
